import { XMarkIcon } from '@heroicons/react/24/outline';
import { ArchiveBoxIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { Modal, Tabs } from 'react-daisyui';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useModalsContext } from 'src/providers/ModalsProvider/Modals.context';
import { RouterPaths } from '../Router/Router.constants';
import './ArchiveLeads.styles.scss';

export default function ArchiveLeadsModal() {
  const { showArchiveLeadsModal, setShowArchiveLeadsModal } =
    useModalsContext();
  const { t } = useTranslation('common/archiveLeads');

  const [tab, setTab] = useState<'massive' | 'individual'>('massive');

  return (
    <Modal
      open={showArchiveLeadsModal}
      backdrop
      onClose={() => setShowArchiveLeadsModal(false)}
      className="ArchiveLeadsModal"
    >
      <Modal.Body className="ArchiveLeadsModal__Body">
        <Modal.Header className="ArchiveLeadsModal__Header">
          <h1>{t('title')}</h1>
          <XMarkIcon
            onClick={() => setShowArchiveLeadsModal(false)}
            className="ArchiveLeadsModal__CloseIcon"
          />
        </Modal.Header>
        <Tabs variant="boxed" size="md">
          <Tabs.Tab
            active={tab === 'massive'}
            className={`ArchiveLeadsModal__Tab ${tab === 'massive' ? 'active' : ''}`}
            onClick={() => setTab('massive')}
          >
            {t('tabs.massive')}
          </Tabs.Tab>
          <Tabs.Tab
            active={tab === 'individual'}
            className={`ArchiveLeadsModal__Tab ${tab === 'individual' ? 'active' : ''}`}
            onClick={() => setTab('individual')}
          >
            {t('tabs.individual')}
          </Tabs.Tab>
        </Tabs>
        {tab === 'massive' ? (
          <>
            <img
              src={'/gif/archive-leads-in-bulk.gif'}
              alt={t('massive.imageAlt')}
              className="rounded-lg"
            />
            <ol className="ArchiveLeadsModal__Steps">
              <li>
                {t('massive.steps.step1')}{' '}
                <Link
                  to={RouterPaths.directory}
                  className="ArchiveLeadsModal__DirectoryLink"
                  onClick={() => {
                    setShowArchiveLeadsModal(false);
                  }}
                >
                  {t('massive.steps.step1Link')}
                </Link>
              </li>
              <li>
                <Trans
                  i18nKey="common/archiveLeads:massive.steps.step2"
                  components={{ strong: <strong /> }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="common/archiveLeads:massive.steps.step3"
                  components={{ strong: <strong /> }}
                />{' '}
                <ArchiveBoxIcon className="ArchiveLeadsModal__ArchiveIcon" />
              </li>
              <li>{t('massive.steps.step4')}</li>
              <li>{t('massive.steps.step5')}</li>
            </ol>
          </>
        ) : (
          <>
            <img
              src={'/gif/archive-lead.gif'}
              alt={t('individual.imageAlt')}
              className="rounded-lg"
            />
            <ol className="ArchiveLeadsModal__Steps">
              <li>{t('individual.steps.step1')}</li>
              <li>
                <Trans
                  i18nKey="common/archiveLeads:individual.steps.step2"
                  components={{ strong: <strong /> }}
                />{' '}
                <ArchiveBoxIcon className="ArchiveLeadsModal__ArchiveIcon" />
              </li>
              <li>{t('individual.steps.step3')}</li>
              <li>{t('individual.steps.step4')}</li>
            </ol>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
